import VisualizadorPdfComponent from '@/components/visualizador-pdf/visualizador-pdf.vue';
import AlertService from '@/shared/alert/alert.service';
import { PersonalBeca } from '@/shared/model/seguimiento/personal-beca.model';
import FormalizacionFormato1SnpService from '@/shared/services/snp/FormalizacionFormato1SnpService';
import PdfSNPService from '@/shared/services/snp/pdf.service';
import { encrypt } from '@/shared/util/cifrado';
import { Component, Emit, Inject, Prop, Vue } from 'vue-property-decorator';
import VerPdfUrl from '@/entities/snp/snippets/verPdfUrl/ver-pdf-url.vue';
import SolicitudService from '@/entities/solicitud/solicitud.service';
import { FirmaFormato1 } from '@/shared/model/snp/formalizacion-formato1.model';

@Component({
  components: {
    'visualizador-pdf': VisualizadorPdfComponent,
    'ver-pdf-url': VerPdfUrl,
  },
})
export default class FirmarFormalizacionSnpComponent extends Vue {
  @Inject('pdfSNPService') private readonly pdfSNPService!: () => PdfSNPService;
  @Inject('alertService') private readonly alertService!: () => AlertService;
  @Inject('formalizacionFormato1SnpService') private readonly formalizacionFormato1SnpService!: () => FormalizacionFormato1SnpService;
  @Inject('solicitudService') private solicitudService!: () => SolicitudService;

  @Prop({ required: true })
  public readonly solicitudId!: string;

  @Prop({ required: true })
  public readonly permitirFirmar!: boolean;

  @Prop({ required: true })
  public readonly personalBeca!: PersonalBeca;

  public firmaFormato1: FirmaFormato1 = new FirmaFormato1();

  public mostrarModalFirmarUno = false;
  public clave = '';
  public tipoCampoClave = 'password';

  public mostrarPdf = false;
  public consultando = false;
  public contenidoBase64 = '';

  public mounted(): void {
    this.consultarDocumento();
  }

  public previsualizarFormato(): void {
    this.mostrarPdf = false;
    this.consultando = true;

    this.pdfSNPService()
      .exportarFormato1FormalizacionPdf(this.solicitudId)
      .then(responseDocumento => {
        this.contenidoBase64 = `data:application/pdf;base64,${responseDocumento.contenidoBase64}`;
        this.mostrarPdf = true;
      })
      .catch(error => {
        this.mostrarPdf = false;
        if (!!error.response?.data?.detail) {
          this.alertService().showError(this, error.response.data.detail);
        } else {
          this.alertService().showHttpError(this, error.response);
        }
      })
      .finally(() => {
        this.consultando = false;
      });
  }

  public verModalClave(): void {
    this.clave = '';
    if (this.permitirFirmar) {
      this.mostrarModalFirmarUno = true;
    }
  }

  public firmarFormato(): void {
    this.mostrarPdf = false;
    this.consultando = true;
    this.mostrarModalFirmarUno = false;

    if (!this.permitirFirmar) {
      return;
    }

    let claveCifrada = '';
    try {
      claveCifrada = encrypt(this.clave, (this.personalBeca?.cvu ?? '').padEnd(32, 'X'));
      this.formalizacionFormato1SnpService()
        .firmarDocumento(this.solicitudId, claveCifrada)
        .then(response => {
          this.emitirCambios();
          this.alertService().showSuccess(this, this.$t('apeironGwApp.formalizacionSnp.firmar.dictamenFirmado').toString());
        })
        .catch(error => {
          this.mostrarPdf = false;
          if (!!error.response?.data?.detail) {
            this.alertService().showError(this, error.response.data.detail);
          } else {
            this.alertService().showHttpError(this, error.response);
          }
        })
        .finally(() => {
          this.clave = '';
          this.consultando = false;
        });
    } catch (error) {
      this.consultando = false;
      this.clave = '';
      this.alertService().showError(this, this.$t('apeironGwApp.formalizacionSnp.firmar.ocurrioUnError').toString());
    }
  }

  private consultarDocumento(): void {
    this.consultando = true;
    this.solicitudService()
      .find(this.solicitudId)
      .then(solicitud => {
        this.firmaFormato1 = solicitud.firmaFormato1 ?? new FirmaFormato1();
      })
      .catch(error => {
        if (!!error.response?.data?.detail) {
          this.alertService().showError(this, error.response.data.detail);
        } else {
          this.alertService().showHttpError(this, error.response);
        }
      })
      .finally(() => {
        this.consultando = false;
      });
  }

  @Emit('change')
  public emitirCambios(): boolean {
    this.consultarDocumento();
    return true;
  }
}
